import { trackEvent } from '../helpers/track-event';
import { useCookies } from './use-cookies';
export function useTrackEvent() {
    var _a, _b;
    var cookies = useCookies().cookies;
    var csrfToken = (_a = cookies === null || cookies === void 0 ? void 0 : cookies.YII_CSRF_TOKEN) !== null && _a !== void 0 ? _a : '';
    var deviceSessionId = (_b = cookies === null || cookies === void 0 ? void 0 : cookies.device_session_id) !== null && _b !== void 0 ? _b : '';
    var trackEventWrapped = function (props) {
        trackEvent(csrfToken, deviceSessionId, props);
    };
    return [trackEventWrapped];
}
//# sourceMappingURL=use-track-event.js.map